'use client'
import style from '../index.module.scss'
import Typical from 'react-typical'
import { useLayoutEffect, useState, useMemo, useContext, useEffect } from 'react'
import { useInView, InView } from 'react-intersection-observer'
import Link from 'components/Link'
import classNames from 'classnames'
import { languageContext } from '../../../../components/providers/languageProvider'
import Image from 'next/image'
import { getCountryKey } from 'helpers/country'

import adjustUrlList from 'helpers/adjustUrlList'
import QrcodeDownloadApp from './assets/landing-qrcode-download-app.png'
import QrcodePhDownloadApp from './assets/qrcode_ph.png'
import QrcodeSgDownloadApp from './assets/qrcode_sg.png'
const androidUrl = 'https://play.google.com/store/apps/details?id=com.poseidon.bossjobapp '
const iOSUrl = 'https://apps.apple.com/sg/app/bossjob/id1592073585'

export const Title = () => {
  const [show, setShow] = useState(false)
  const { ref } = useInView({
    /* Optional options */
    threshold: 1,
    delay: 2000
  })

  useLayoutEffect(() => {
    setTimeout(() => {
      setShow(true)
    })
  })
  const countryKey = getCountryKey()
  const contextLang = useContext(languageContext)

  const TypC = useMemo(() => {
    return <Typical steps={[contextLang.landing.section1_title]} wrapper={'h1'} />
  }, [])
  return (
    <div className={style.titleWrapper} ref={ref}>
      <div className={style.title + ' ' + style['title-color']} style={{ height: 112 }}>
        {show && TypC}
      </div>
      <InView threshold={0.2} triggerOnce={true}>
        {({ inView, ref }) => {
          return (
            <h1
              ref={ref}
              className={classNames({
                [style.op0]: true,
                [style.section1_subtitle + ' ' + style.height]: true,
                [style.animate__bounceIn]: inView
              })}
            >
              {contextLang.landing.section1_subtitle}
            </h1>
          )
        }}
      </InView>

      <InView threshold={0.2} triggerOnce={true}>
        {({ inView, ref }) => {
          return (
            <div
              ref={ref}
              className={classNames({
                [style.getApp + ' ' + style.mobile]: true,
                [style.animate__bounceIn]: inView
              })}
            >
              <div
                className={style.download_btn}
                onClick={() => {
                  window.open(
                    adjustUrlList[1]?.link?.[countryKey] ?? adjustUrlList[1]?.link?.default
                  )
                }}
              >
                {contextLang.landing.section1_getApp} 👈
              </div>
            </div>
          )
        }}
      </InView>

      <div className={style.boxWrapper}>
        <div>
          <Link
            className={style.download_btn}
            href={adjustUrlList[5]?.link?.[countryKey] ?? adjustUrlList[5]?.link?.default}
            target={'_blank'}
          >
            <span>Apple store</span>
            <img src={`${process.env.S3_BUCKET_URL}/landing/apple.svg`} alt={'apple'} />
          </Link>
        </div>
        <div>
          <Link
            className={style.download_btn + ' ' + style.google}
            href={adjustUrlList[5]?.link?.[countryKey] ?? adjustUrlList[5]?.link?.default}
            target={'_blank'}
          >
            <span>Google play</span>
            <img src={`${process.env.S3_BUCKET_URL}/landing/google.svg`} alt={'google'} />
          </Link>
        </div>

        <div className={style.qrcode}>
          <Image
            src={
              countryKey === 'ph'
                ? QrcodePhDownloadApp
                : countryKey === 'sg'
                ? QrcodeSgDownloadApp
                : QrcodeDownloadApp
            }
            width={75}
            height={75}
            alt='_'
          />
        </div>
      </div>
    </div>
  )
}

export default Title
